<div class="icon-title">
  <div class="icon-title__icon">
    <ng-content select="[icon]"></ng-content>
  </div>
  <h2 class="icon-title__title">
    <ng-content></ng-content>
  </h2>
  <span class="icon-title__subheader" *ngIf="subHeader">{{ subHeader }}</span>
</div>
